const formWrapperEl = document.getElementsByClassName("form-wrapper")[0]
const confirmedStepWrapperEl = document.getElementsByClassName("confirm-step-wrapper")[0]
const card_cardholderNameEl = document.getElementsByClassName("holder-name")[0]
const card_cardNumberEl = document.getElementsByClassName("card-number")[0]
const card_expireDateEl = document.getElementsByClassName("expire")[0]
const card_cvcEl = document.getElementsByClassName("cvc")[0]

const form_cardholderNameInput = document.getElementById("cardholder-name")
const form_cardNumberInput = document.getElementById("card-number")
const form_expireDateMonthInput = document.getElementById("exp-month")
const form_expireDateYearInput = document.getElementById("exp-year")
const form_cvcInput = document.getElementById("cvc-code-input")
const form_confirmBtn = document.getElementsByClassName("confirm-btn")[0]
const from_continueBtn = document.getElementsByClassName("continue-btn")[0]

const formEl = {
    cardHolder: form_cardholderNameInput,
    cardNumber: form_cardNumberInput,
    expireMonth: form_expireDateMonthInput,
    expireYear: form_expireDateYearInput,
    cvc: form_cvcInput,
    confirmBtn: form_confirmBtn,
    continueBtn: from_continueBtn,
    toggleStep: () => {
        formWrapperEl.toggleDisplayNone()
        confirmedStepWrapperEl.toggleDisplayNone()
    },
    clear: () => {
        document.querySelectorAll(".form-wrapper input:not(.btn-primary)")
            .forEach(el => {
                el.value = ""
            });
    },
    resetValidityStatus: () => {
        // Reset validity status of input elements
        Object.entries(formEl).forEach(([_, v]) => {
            if (v.nodeName !== undefined && v.nodeName === "INPUT") {
                v.setCustomValidity("")
            }
        })
    }
}

const cardEl = {
    cardholder: card_cardholderNameEl,
    cardNumber: card_cardNumberEl,
    expireDate: card_expireDateEl,
    cvc: card_cvcEl
}

formWrapperEl.toggleDisplayNone = toggleDisplayNone;
confirmedStepWrapperEl.toggleDisplayNone = toggleDisplayNone;

function toggleDisplayNone() {
    this.classList.toggle("d-none")
}

export { cardEl, formEl }